import script from "./RacEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RacEditPage.vue?vue&type=script&setup=true&lang=js"

import "./RacEditPage.vue?vue&type=style&index=0&id=15d2af5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d2af5b"]])

export default __exports__